// extracted by mini-css-extract-plugin
export var equalColumn = "_hl-0";